// extracted by mini-css-extract-plugin
module.exports = {"AppLogoContainer":"LoadingData_AppLogoContainer__24C8N","AppLogo":"LoadingData_AppLogo__1Q8qt","AppLogoSpin":"LoadingData_AppLogoSpin__MzaMC"};